module.exports = __webpack_public_path__ + "static/media/fin.65a90e74.svg";